var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDirection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Direction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Direction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999976,11.9261493 C15.9940746,12.0717978 15.9318823,12.2400576 15.8282284,12.3463912 L12.4436138,15.8091603 C12.2143061,16.0077719 11.7793832,16.0921055 11.5181332,15.8600863 C11.2655563,15.6341783 11.2731717,15.1960104 11.5246909,14.9690838 L13.9044981,12.5372621 L5.63461525,12.5372621 C5.3022884,12.5372621 5,12.245965 5,11.9261493 L5,5.5946128 C5,5.2570748 5.28409609,5 5.63461525,5 C5.9851344,5 6.2692305,5.2570748 6.2692305,5.5946128 L6.2692305,11.3150364 L13.9044981,11.3150364 L11.5246909,8.88321471 C11.3080756,8.67421412 11.2680948,8.22056468 11.5181332,7.99200848 C11.7679601,7.76324857 12.2236138,7.83637841 12.4436138,8.04293455 L15.8282284,11.5059073 C15.94394,11.6244632 16.0004207,11.7635932 15.9999976,11.9261493 Z",
    id: "Fill-1",
    stroke: "#0078D7",
    strokeWidth: 0.5,
    fill: "#0078D7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirection);
export default __webpack_public_path__ + "static/media/ic_direction.27239044771a90cc4fd52459e683dd04.svg";
export { ForwardRef as ReactComponent };